import { Button } from "@/components/ui/baseUi/button"
import { cn } from "@/modules/lib/utils"
import { BoxSettingsForm } from "@modules/box/components/boxSettingsForm/boxSettingsForm"
import { BoxSettingsSideCard } from "@modules/box/components/boxSettingsForm/boxSettingsSideCard"
import { useBoxSettingsForm } from "@modules/box/hooks/useBoxSettingsForm"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { word } from "@modules/core/utils/i18n"
import { minScreenWidth } from "@modules/ui/uiConstants"
import { LoaderCircle } from "lucide-react"
import { useRef } from "react"

type BoxSettingsWrapperProps = {
  className?: string
} & React.ComponentProps<"div">

export function BoxSettingsWrapper({ className, ...props }: BoxSettingsWrapperProps) {
  const { form } = useBoxSettingsForm()
  const canEditGymInformation = useBoxStaffPermission(BoxStaffPermissions.EDIT_GYM_INFORMATION)

  const containerRef = useRef<HTMLFormElement>(null)

  const scrollToFirstError = () => {
    const errorElements = containerRef.current?.querySelectorAll('[aria-invalid="true"]')
    if (errorElements && errorElements.length > 0) {
      const y = (errorElements[0] as HTMLElement).getBoundingClientRect().top + window.pageYOffset - 30
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }

  return (
    <div className={cn("flex justify-center", className)} style={{ minWidth: minScreenWidth }} {...props}>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          void form.handleSubmit().then(() => {
            requestAnimationFrame(scrollToFirstError)
          })
        }}
        className="flex flex-col"
        ref={containerRef}
      >
        <div className="mb-4 flex flex-col justify-center gap-4 md:flex-row">
          <BoxSettingsForm form={form} />

          <BoxSettingsSideCard />
        </div>

        <div className="flex justify-end">
          <form.Subscribe selector={(state) => state.isSubmitting}>
            {(isSubmitting) => (
              <Button
                type="submit"
                isLoading={isSubmitting}
                variant="primary"
                size="lg"
                disabled={!canEditGymInformation || isSubmitting}
              >
                {isSubmitting && <LoaderCircle className="animate-spin" />}
                {word("global.save")}
              </Button>
            )}
          </form.Subscribe>
        </div>
      </form>
    </div>
  )
}
